import { GetImporterProcessFileContentDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface Props {
  importerProcessUuid: string
  maxRows?: number
}

export const useGetImporterProcessFileContent = ({ importerProcessUuid, maxRows }: Props) => {
  const { data, loading } = useQuery(GetImporterProcessFileContentDocument, {
    variables: {
      importerProcessUuid,
      maxRows,
    },
  })

  const normalizedRows =
    data?.importers.importerProcessFileContentsConnection.edges[0]?.node.rows.map((row) => {
      return row?.row.map((cell) => {
        return cell
      })
    })

  const fileContent = {
    headers: data?.importers.importerProcessFileContentsConnection.edges[0]?.node.headers,
    rows: normalizedRows,
  }

  return {
    loading,
    fileContent,
  }
}
